var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3.03516H3.5C3.01675 3.03516 2.625 3.42691 2.625 3.91016V10.0352C2.625 10.5184 3.01675 10.9102 3.5 10.9102H7.875C8.35825 10.9102 8.75 10.5184 8.75 10.0352V3.91016C8.75 3.42691 8.35825 3.03516 7.875 3.03516Z",
    stroke: "#1E73BE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.03516H13.125C12.6418 3.03516 12.25 3.42691 12.25 3.91016V6.53516C12.25 7.01841 12.6418 7.41016 13.125 7.41016H17.5C17.9832 7.41016 18.375 7.01841 18.375 6.53516V3.91016C18.375 3.42691 17.9832 3.03516 17.5 3.03516Z",
    stroke: "#1E73BE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.9102H13.125C12.6418 10.9102 12.25 11.3019 12.25 11.7852V17.9102C12.25 18.3934 12.6418 18.7852 13.125 18.7852H17.5C17.9832 18.7852 18.375 18.3934 18.375 17.9102V11.7852C18.375 11.3019 17.9832 10.9102 17.5 10.9102Z",
    stroke: "#1E73BE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 14.4102H3.5C3.01675 14.4102 2.625 14.8019 2.625 15.2852V17.9102C2.625 18.3934 3.01675 18.7852 3.5 18.7852H7.875C8.35825 18.7852 8.75 18.3934 8.75 17.9102V15.2852C8.75 14.8019 8.35825 14.4102 7.875 14.4102Z",
    stroke: "#1E73BE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.b491c195661c8102b587102b2fc7181a.svg";
export { ForwardRef as ReactComponent };